/** Max length for rack and temporary_rack — must match Order model CharField max_length. */
export const RACK_FIELD_MAX_LENGTH = 50;
